import { Route, Location } from "vue-router";

export const substituteEventId = (to: Route, newEventId: string, addHash = false) => {
    const newLocation: Location = { name: to.name as string, params: { ...to.params, eventId: newEventId } }

    if (addHash) {
        newLocation.hash = to.hash;
    }

    return newLocation;
}
